import React from 'react'
import GroupLogoOrnamentsSvg from '../other/svg/GroupLogoOrnamentsSvg'
import GroupLogoCenterSvg from '../other/svg/GroupLogoOverlaySvg'

const Spinner = (): JSX.Element => {
  return (
    <div className="flex justify-center items-center flex-1 h-[100vh] bg-groupBlue mt-[-20px]">
      <div className="relative">
        <div className={'w-fit animate-spin pt-1 pl-1'} style={{ animationDuration: '2s' }}>
          <GroupLogoOrnamentsSvg />
        </div>
        <div className="absolute top-0 left-0">
          <GroupLogoCenterSvg />
        </div>
      </div>
    </div>
  )
}

export default Spinner
